<template>
    <h1 class="display-1 font-weight-light my-3">{{title}}</h1>
</template>

<script>
export default {
    props: ['title']
}
</script>
